
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.5 24c0 8.562-6.94 15.5-15.5 15.5-8.56 0-15.5-6.938-15.5-15.5 0-8.557 6.94-15.5 15.5-15.5 8.56 0 15.5 6.943 15.5 15.5zM24 27.125a2.875 2.875 0 100 5.75 2.875 2.875 0 000-5.75zm-2.73-10.334l.464 8.5a.75.75 0 00.749.709h3.034a.75.75 0 00.749-.71l.464-8.5a.75.75 0 00-.75-.79h-3.96a.75.75 0 00-.75.79z","fill":"#535353"}})])
          )
        }
      }
    